import Vue from 'vue'
import Vuex from 'vuex'

import { authentication } from './authentication.module'
import { channel } from './channel.module'
import { users } from './user.module'
import { subscribe } from './subscribe.module'
import { charge } from './charge.module'
import { category } from './category.module'
import { series } from './series.module'
import { publication } from './publication.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    authentication,
    channel,
    users,
    subscribe,
    charge,
    category,
    series,
    publication
  }
});